import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AnchoredNotificationAlert } from '@noths/polaris-client-ribbons-design-system';

import { actions } from 'src/redux/basket/slice';
import type { ReduxApplicationState } from 'src/redux/types';
import { BasketErrorNotificationWrapper } from './BasketErrorNotificationWrapper';
import * as styles from './BasketErrorNotification.styles';

const ERROR_NOTIFICATION_TESTID = 'error-notification';
const ERROR_NOTIFICATION_MESSAGE_ID = 'error-notification-message';

export const BasketErrorNotification = () => {
  const error = useSelector((state: ReduxApplicationState) => state.basket.error);
  const dispatch = useDispatch();

  if (error === null) {
    return null;
  }

  return (
    <BasketErrorNotificationWrapper>
      <div
        aria-describedby={ERROR_NOTIFICATION_MESSAGE_ID}
        css={styles.addToBasketAlert}
        data-testid={ERROR_NOTIFICATION_TESTID}
        role="alertdialog"
      >
        <AnchoredNotificationAlert
          onClose={() => {
            dispatch(actions.clearBasketError());
          }}
        >
          <strong css={styles.addToBasketAlertTextBox} id={ERROR_NOTIFICATION_MESSAGE_ID}>
            {error.code ? `${error.code}: ` : ' '}
            {error.message}
          </strong>
        </AnchoredNotificationAlert>
      </div>
    </BasketErrorNotificationWrapper>
  );
};
